import { LatLngType } from "../ts-types/mapsTypes";
import { BuildingPolygons } from "./buildingProximityAlgorithm";

export const convertStructuresToBuildingPolygons = (
  structures: Array<{ outer: LatLngType[] }>,
): BuildingPolygons => {
  const result: BuildingPolygons = {};

  structures.forEach((structure, index) => {
    if (structure.outer && structure.outer.length > 0) {
      result[`structure_${index}`] = structure.outer.map((point) => [
        point.lat,
        point.lng,
      ]);
    }
  });

  return result;
};
